import React from "react";

import { Box } from "@catchoftheday/cg-components";

import { PriceTag } from "../ProductCard/productCardTypes";

import { ProductPriceLabel } from "./ProductPriceLabel/ProductPriceLabel";
import { ProductPriceOnePass } from "./ProductPriceOnePass";
import { ProductPriceSell } from "./ProductPriceSell";

type ProductPriceProps = {
  priceTag: PriceTag;
  large?: boolean;
};

export const ProductPrice = ({
  priceTag,
  large = false,
}: ProductPriceProps) => {
  const {
    priceDiscount,
    topLabel,
    priceLabel,
    clubSellPrice,
    enabled,
    clubExclusive,
    retailPriceDisclaimer,
  } = priceTag;

  const hasDisplayLabel = !!priceDiscount || !!topLabel;

  return (
    <Box
      display="inline-flex"
      flex="1 1 auto"
      flexDirection="column"
      fontSize={large ? "2.5rem" : "1.75rem"}
      lineHeight={1}
      alignItems={large ? { xs: "center", lg: "flex-start" } : "center"}
      mt={hasDisplayLabel ? "0px" : "16px"}
    >
      <ProductPriceLabel
        discount={priceDiscount}
        topLabel={topLabel}
        enabled={enabled}
        large={large}
        retailPriceDisclaimer={retailPriceDisclaimer?.description}
      />

      <ProductPriceSell
        price={priceLabel.price.amount}
        saving={priceLabel.saving}
        wasPrice={priceLabel.wasPrice?.amount}
        onePassExclusive={clubExclusive}
        hasPromotion={!!priceTag.priceDiscount}
        enabled={enabled}
        large={large}
      />
      {clubSellPrice && enabled && (
        <ProductPriceOnePass price={clubSellPrice.amount} large={large} />
      )}
    </Box>
  );
};
